module.exports = __webpack_public_path__ + "img/tile-03.d626a055.png";